module.exports = __webpack_public_path__ + "pw.svg?2c7e97aee48d185abb51fe9720a9fcb4";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/pw.svg
// module id = 1111
// module chunks = 27